<template>
  <div class="index">
    <!-- 3D大脑背景 -->
    <div class="brain-container">
      <Brain3DInteractive :cameraDistance="cameraDistance" />
    </div>

    <!-- 脑图容器 -->
    <div class="force-star-container">
      <force-star
          v-if="forceData.nodes.length"
          :forceData="forceData"
          :bondList="bondList"
          @zoom-changed="handleZoomChange">
      </force-star>
    </div>

    <div class="logo-box" @click="handleToHomePage">
      <div class="logo-before-B">
        <div>B</div>
        <div class="logo-after-B">B</div>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="!isNotFirstSearch"
        style="
          color: white;
          transform: translate(-50%, -50%);
          position: absolute;
          top: 35%;
          left: 50%;
          text-align: center;
          z-index: 100;
        "
      >
        <div
          style="font-size: 51px; color: rgb(154, 182, 200); font-weight: 700"
        >
          Bookor Brain
        </div>
        <div style="font-size: 26px; font-weight: 600">联想 洞见 创见</div>
        
        <!-- SSE加载状态指示器 -->
        <div v-if="isLoadingKeywords" style="margin-top: 20px; font-size: 16px; color: rgb(154, 182, 200);">
          <div style="margin-bottom: 10px;">
            <i class="el-icon-loading" style="margin-right: 8px;"></i>
            正在流式加载关键词星云...
          </div>
          <div style="font-size: 14px; opacity: 0.8;">
            已加载 {{ loadedKeywordsCount }} 个关键词节点
          </div>
        </div>
      </div>
    </transition>
    <div
      :style="{
        position: 'absolute',
        top: isNotFirstSearch ? (isMobile ? '5px' : '10px') : '50%',
        left: '50%',
        transition: 'all 0.5s ease',
        transform: isNotFirstSearch
          ? 'translateX(-50%)'
          : 'translate(-50%, -50%)',
        'z-index': 10
      }"
    >
      <IndexSearch :forceData="forceData" :bondList="bondList"/>
    </div>
    <drop-welt />
    <div ref="cubeInfo" class="cube-info"></div>
  </div>
</template>

<script>
import request from '@/http/request'
import DropWelt from '@/components/dropwelt/index'
import ForceStar from '@/components/force-star/index'
import IndexSearch from '@/components/index-search/index'
import { mapState } from 'vuex'
import { getRandomColor, pointConvertNode, lineConvertLink } from '../components/force-star/utils'
import Brain3DInteractive from '@/components/homepage/brain3d/Brain3DInteractive.vue'
import { EventBus } from '@/main.js'

// 添加SSE支持
import { fetchEventSource } from '@microsoft/fetch-event-source'
export default {
  name: 'Index',
  components: {
    ForceStar,
    DropWelt,
    IndexSearch,
    Brain3DInteractive
  },
  data () {
    return {
      forceData: {
        nodes: [],
        links: []
      },
      bondList: [],
      tagList: [],
      offX: 0,
      isMobile: false,
      isLoadingKeywords: false,
      loadedKeywordsCount: 0,
      cameraDistance: 100
    }
  },
  computed: {
    scrollWrapper () {
      return this.$refs.scrollContainer.$refs.wrap
    },
    ...mapState('indexsearch', {
      isNotFirstSearch: (state) => state.isNotFirstSearch
    })
  },
  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {
        const keyword = newQuery.keyword;
        const bookId = newQuery.bookId;
        
        // 只有当query参数存在且发生变化时才触发搜索
        if (keyword && keyword.trim() && keyword !== oldQuery?.keyword) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.triggerSearch(keyword);
              if (bookId) {
                this.openBookDetail(bookId);
              }
            }, 1500);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },

  created () {
    const finishedSplash = sessionStorage.getItem('finishedSplash')
    if (finishedSplash && finishedSplash === 'true') {
      this.$store.commit('SETISSHOWSPLASH', false)
    } else {
      setTimeout(() => {
        this.$store.commit('SETISSHOWSPLASH', true)
      }, 13000)
    }
  },
  methods: {
    triggerSearch(keyword, retryCount = 0) {
      // 如果数据还没加载完成，等待后重试（最多5次）
      if (this.forceData.nodes.length === 0 && retryCount < 5) {
        setTimeout(() => {
          this.triggerSearch(keyword, retryCount + 1);
        }, 2000);
        return;
      }
      
      if (this.forceData.nodes.length === 0) {
        this.$message.warning('数据加载中，请稍后手动搜索');
        return;
      }
      
      EventBus.$emit('triggerIndexSearch', keyword);
    },
    
    openBookDetail(bookId) {
      this.$store.commit('book/SET_CHOSED_BOOK_ID', parseInt(bookId));
      this.$store.commit('book/showDetails');
    },
    handleZoomChange (distance) {
      const minStarDist = 1400
      const maxStarDist = 18000
      const minBrainDist = 100
      const maxBrainDist = 200
      const finalMinBrainDist = 50

      const logStarMin = Math.log(minStarDist)
      const logStarMax = Math.log(maxStarDist)
      const logDist = Math.log(distance)

      const scale = (logDist - logStarMin) / (logStarMax - logStarMin)
      const newBrainDist = minBrainDist + scale * (maxBrainDist - minBrainDist)

      this.cameraDistance = Math.max(finalMinBrainDist, newBrainDist)
    },
    handleToHomePage () {
      this.$router.push('/editor/note')
    },
    getLinks (nodes, list) {
      const listMap = new Map()
      const newList = []
      list.forEach((item) => {
        if (!listMap.has(item.mix_keywords_lines_id)) {
          listMap.set(item.mix_keywords_lines_id)
          newList.push(item)
        }
      })
      this.bondList = newList
      let points = []
      let pointLinks = []
      for (let i = 0; i < newList.length; i++) {
        const item = newList[i]
        const nodes = pointConvertNode(item.point_list, item.title[0])
        const links = lineConvertLink(nodes, item.line_list)
        points = [...points, ...nodes]
        pointLinks = [...pointLinks, ...links]
      }
      this.forceData.nodes = [...nodes, ...points]
      this.forceData.links = pointLinks
    },
    getCategoryList () {
      request('/api/Nebula/keywordsCategoryList', {}).then((result) => {
        this.tagList = result
      })
    },
    getData () {
      this.forceData.nodes = []
      this.isLoadingKeywords = true
      this.loadedKeywordsCount = 0
      
      const ctrl = new AbortController()
      
      fetchEventSource('/api/Nebula/keywordsListAll', {
        method: 'GET',
        signal: ctrl.signal,
        headers: {
          'Accept': 'text/event-stream',
          'Cache-Control': 'no-cache',
          'Authorization': localStorage.getItem('authorization') || ''
        },
        onopen: async (response) => {
          if (response.ok) {
            return
          } else {
            throw new Error(`SSE连接失败: ${response.status} ${response.statusText}`)
          }
        },
        onmessage: (event) => {
          try {
            if (event.data.includes('连接将关闭')) {
              this.isLoadingKeywords = false;
              ctrl.abort();
              return;
            }
            
            const keywordList = JSON.parse(event.data);
            
            if (Array.isArray(keywordList)) {
              const newNodes = keywordList.map(keywordItem => ({
                id: parseInt(Math.random() * 100000000000000000),
                user: keywordItem.keywords,
                color: getRandomColor(),
                bookId: keywordItem.book_keywords_id,
                nodeId: keywordItem.member_keywords_id
              }));

              this.forceData.nodes = [...this.forceData.nodes, ...newNodes];
              this.loadedKeywordsCount = this.forceData.nodes.length;
            }
          } catch (error) {
            console.error('解析SSE数据失败:', error);
          }
        },
        onclose: () => {
          this.isLoadingKeywords = false
        },
        onerror: (error) => {
          this.isLoadingKeywords = false
          this.getDataFallback()
          throw error
        }
      })
    },
    
    getDataFallback () {
      request('/api/Nebula/newKeywordsList', {}).then((result) => {
        const list = result
        const nodes = []
        for (let i = 0; i < list.length; i += 1) {
          const item = list[i]
          nodes.push({
            id: parseInt(Math.random() * 100000000000000000),
            user: item.keywords,
            color: getRandomColor(),
            bookId: item.book_keywords_id,
            nodeId: item.member_keywords_id
          })
        }
        this.forceData.nodes = [...nodes]
      }).catch((error) => {
        this.$message.error('获取关键词数据失败，请刷新页面重试')
      })
    },
    getCategory (categoryId, common) {
      this.forceData.nodes = []
      request('/api/Nebula/getKeywordsByCategory', {
        category_id: categoryId,
        type: common
      }).then((result) => {
        const list = result.point_data
        if (!list.length) {
          this.$message.info('暂无词条')
          return
        }
        const nodes = []
        for (let i = 0; i < list.length; i += 1) {
          const item = list[i]
          nodes.push({
            id: parseInt(Math.random() * 100000000000000000),
            user: item.keywords,
            color: getRandomColor(),
            bookId: item.book_keywords_id,
            nodeId: item.member_keywords_id
          })
        }
        this.getLinks(nodes, result.line_data)
      })
    }
  },
  mounted () {
    this.getCategoryList()
    this.getData()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/index.scss";
@import "@/assets/scss/global.scss";
.index-mask {
  @include mask;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 3s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  transition: all 0.5s ease-out;
  opacity: 0;
}
.brain-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1; /* 底层 */
}
.force-star-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2; /* 上层 */
  mix-blend-mode: screen;
}
.logo-box{
  z-index: 100;
}
</style>
